/**
 * feature-config flag names owned by shared-services
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const SHARED_SERVICES_FLAG_NAMES = {
  ADMIN_BLOCKED_EMAILS_PERMISSIONS:
    'ff-shsvs-8550-admin-blocked-emails-permissions',
  ADMIN_WORKSPACE_PAGE_SITE_PAGINATION:
    'ff-shsvs-8008-admin-workspace-page-site-pagination',
  ADMIN_LIBRARY_INSTALL: 'ff-csy-386-admin-library-install',
  BOTTOM_RIGHT_KNOCK_GUIDE_NOTIFICATION:
    'ff-shsvs-7957-bottom-right-knock-guide-notification',
  CONNECT_TO_SPRIG: 'ff-shsvs-7908-connect-to-sprig',
  FEATURE_CONFIG_DASHBOARD: 'ff-shsvs-6249-feature-config-dashboard',
  FLAG_TEST: 'ff-flag-test',
  IPN_SLOT_MECHANISM: 'ff-shsvs-8011-ipn-slot-mechanism',
  LOAD_SERVER_CONFIG: 'ff-shsvs-7599-load-server-config',
  NOTIFICATION_ATC_SEND_COLLISION_EVENT:
    'ff-shsvs-8426-notification-atc-send-collision-event',
  SHOULD_LOAD_WEBFLOW_NEXT_CONTEXT:
    'ff-shsvs-7840-should-load-webflow-next-context',
  STATUS_BANNER_IPN: 'ff-shsvs-8014-status-banner-ipn',
  SHOULD_LOAD_ENTERPRISE_CONTEXT:
    'ff-shsvs-8054-should-load-enterprise-context',
  SESSION_REPLAY_ELIGIBLE_FLAGS: 'ff-shsvs-session-replay-eligible-flags',
  SESSION_REPLAY_RECORDING_ENABLED: 'ff-shsvs-session-replay-recording-enabled',
  SIDEBAR_BANNER_CALENDLY_CTA: 'ff-shsvs-8150-sidebar-banner-calendly-cta',
  IPN_SEAT_NUDGE_PAGES_MILESTONE: 'ff-col-7018-ipn-seat-nudge-pages-milestone',
  RENDER_REACT_ADMIN_PAGES: 'ff-shsvs-8616-render-react-admin-pages',
};
